import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-right"><path d="M14.2367 4.17939C14.0141 3.98952 13.7014 3.94643 13.4358 4.06901C13.1701 4.19158 13 4.45744 13 4.75001V8.00001H2.75C2.33579 8.00001 2 8.3358 2 8.75001V15.25C2 15.6642 2.33579 16 2.75 16H13V19.25C13 19.5426 13.1701 19.8084 13.4358 19.931C13.7014 20.0536 14.0141 20.0105 14.2367 19.8206L22.7367 12.5706C22.9038 12.4281 23 12.2196 23 12C23 11.7804 22.9038 11.5719 22.7367 11.4294L14.2367 4.17939Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathRight;
